import { render } from "./OlapMDXQueryDialog.vue?vue&type=template&id=3bed0cd2&ts=true"
import script from "./OlapMDXQueryDialog.vue?vue&type=script&lang=ts"
export * from "./OlapMDXQueryDialog.vue?vue&type=script&lang=ts"

import "./OlapMDXQueryDialog.vue?vue&type=style&index=0&id=3bed0cd2&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__